import { useMemo } from 'react';
import { usePaginatedQuery, useQuery } from 'convex/react';
import { api } from '../../api';
import { useEffectiveSerial } from './useEffectiveSerial';

export interface BlockedApp {
  id: string;
  name: string;
  icon: string;
  bundleId: string;
  source: 'device' | 'level';
}

export const useBlockedApps = () => {
  // NOTE: api.devices.list.all requires support/admin role in Convex backend.
  // Self-managed users don't have this role, so we skip all admin queries
  // and return empty data. This prevents "Not authorized" errors.
  //
  // A future improvement would use a device-specific endpoint that
  // doesn't require admin privileges.

  return {
    blockedApps: [],
    hasAppleAppStore: false,
    isLoading: false,
    isLoadingConfig: false,
    deviceAppConfig: null
  };
};
